import { Box } from "@mui/material";
import React, { useEffect } from "react";
import Sidebar from "../../components/SidebarLayout/Sidebar";
import ChecklistGracePeriodContent from "../../components/Masters/ChecklistGracePeriod/ChecklistGracePeriodContent";
import { useDispatch, useSelector } from "react-redux";
import { getDepartmentMasterList } from "../../redux/actions/mastersAction";
const ChecklistGracePeriod = () => {
  const dispatch = useDispatch();
  const CompanyID = localStorage.getItem("companyID");

  useEffect(() => {
    dispatch(
      getDepartmentMasterList({
        companyId: CompanyID,
      })
    );
  }, []);
  return (
    <>
      <Sidebar activeTab="Masters" title="Masters">
        <Box className="globalContainer_For_Content">
          <ChecklistGracePeriodContent />
        </Box>
      </Sidebar>
    </>
  );
};

export default ChecklistGracePeriod;
